import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  data: [],
  loading: false,
  error: null,
  adminNote: "",
}

const returnRequestSlice = createSlice({
  name: "returnRequest",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    setError(state, action) {
      state.error = action.payload
    },
    setAdminNote(state, action) {
      state.adminNote = action.payload
    },
    resetState(state) {
      state.data = []
      state.loading = false
      state.error = null
      state.adminNote = ""
    },
  },
})

export const returnRequestAction = returnRequestSlice.actions

export default returnRequestSlice
